import {
  ADMIN_CHANGE_ARTIST,
  USER_APPLY_ARTIST,
  USER_GET_PLAN,
  USER_GET_ROLE,
  USER_LOGIN,
  USER_LOGOUT
} from '../app/constant'

export const userLogin = (info) => {
    return {
        type: USER_LOGIN,
        info: info
    }
}

export const userLogout = () => {
    return {
        type: USER_LOGOUT
    }
}

export const userUpdateRole = (info) => {
    return {
        type: USER_GET_ROLE,
        info: info
    }
}

export const userUpdatePlan = (info) => {
    return {
        type: USER_GET_PLAN,
        plan: info
    }
}

export const userUpdateArtistApply = (info) => {
    return {
        type: USER_APPLY_ARTIST,
        info: info
    }
}

export const switchArtist = (info) => {
    // alert(JSON.stringify(info));
    return {
        type: ADMIN_CHANGE_ARTIST,
        info: info
    }
}
